export const authTypes = {
  POST_SIGN_ADMIN_PENDING: "POST_SIGN_ADMIN_PENDING",
  POST_SIGN_ADMIN_SUCCESS: "POST_SIGN_ADMIN_SUCCESS",
  POST_SIGN_ADMIN_FAILED: "POST_SIGN_ADMIN_FAILED",
};
